<div class="document-buttons" [ngClass]="{ 'document-buttons-chico': document_buttons_chico }">
  <div>
    <div id="btn-general" class="document-button" [ngClass]="activeForm == 'general' ? 'selected' : ''"
      (click)="emitchangeForm('general')" >
      <button type="submit" class="btn-documents">
        <i class="icon-clipboard-empty"></i>
        {{ "forms.buttons.general" | translate }}
        <span *ngIf="updatesTabs.includes('general')" class="violet-dot"></span>
      </button>
    </div>
    <div id="btn-vehicle" class="document-button" [ngClass]="activeForm == 'vehicle' ? 'selected' : ''"
      (click)="emitchangeForm('vehicle')" >
      <button type="submit" class="btn-documents">
        <i class="icon-car"></i>
        {{ "forms.buttons.vehicle" | translate }}
        <span *ngIf="updatesTabs.includes('vehicle')" class="violet-dot"></span>
      </button>
    </div>

    <div id="btn-currency" class="document-button" [ngClass]="activeForm == 'currency' ? 'selected' : ''"
      (click)="emitchangeForm('currency')" >
      <button type="submit" class="btn-documents">
        <i class="icon-bag-dollar"></i>
        {{ "forms.buttons.currency" | translate }}
        <span *ngIf="updatesTabs.includes('currency')" class="violet-dot"></span>
      </button>
    </div>

    <div id="btn-matrix-type" class="document-button" [ngClass]="activeForm == 'matrix_by_type' ? 'selected' : ''"
      (click)="emitchangeForm('matrix_by_type')" >
      <button type="submit" class="btn-documents">
        <i class="icon-grid"></i>
        {{ "forms.buttons.matrix_by_type" | translate }}
        <span *ngIf="updatesTabs.includes('matrix_by_type')" class="violet-dot"></span>
      </button>
    </div>

    <div id="btn-vehicle" class="document-button" [ngClass]="activeForm == 'broker_exclude' ? 'selected' : ''"
      (click)="emitchangeForm('broker_exclude')" *ngIf="showBrokerExcludeTab && !hideTab('broker_exclude')">
      <button type="submit" class="btn-documents">
        <i class="icon-group-work"></i>
        {{ "forms.buttons.broker" | translate }}
        <span *ngIf="updatesTabs.includes('broker_exclude')" class="violet-dot"></span>
      </button>
    </div>
<div id="btn-doc-campaign" class="document-button" [ngClass]="activeForm == 'doc-campaign' ? 'selected' : ''"
      (click)="emitchangeForm('doc-campaign')">
      <button type="submit" class="btn-documents">
        <i class="icon-files"></i>
        {{ "forms.buttons.doc-order" | translate }}
        <span *ngIf="updatesTabs.includes('doc-campaign')" class="violet-dot"></span>
      </button>
    </div>
    <div id="btn-timeline" class="document-button" [ngClass]="activeForm == 'timeline' ? 'selected' : ''"
      (click)="emitchangeForm('timeline')" *ngIf="!hideTab('timeline')">
      <button type="submit" class="btn-documents">
        <i class="icon-align-left"></i>
        {{ "forms.buttons.timeline" | translate }}
        <span *ngIf="updatesTabs.includes('timeline')" class="violet-dot"></span>
      </button>
    </div>

  </div>
</div>
